import React from "react"

import NoExist from "@irati/ui/src/Layout/NoExist"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import StyledButton from "./styled/ErrorContinueButton"

const InvalidCategory = () => {
  return (
    <NoExist
      additionalElement={
        <StyledButton to="/categories" primary large>
          <FormattedMessage id="perks.components.dealList.invalidCategory.returnDeals" />
        </StyledButton>
      }>
      <FormattedMessage id="perks.components.dealList.invalidCategory.body.pt1" /><br />
      <FormattedMessage id="perks.components.dealList.invalidCategory.body.pt2" />
    </NoExist>
  )
}

export default injectIntl(InvalidCategory)
